import React, { useRef } from "react"
import {
  Container,
  Col,
  Row, Button, Collapse
} from "reactstrap"
import labels from "../Topics/const"
import labels2 from "./const"
import useLabels from "../../utils/useLabels"
import Dots from "../Dots"

import * as s from "./style.module.css"
import Topics from "../Topics"

export default function Mentors({ lang }) {
  const t = useLabels(labels, lang)
  const t2 = useLabels(labels2, lang)


  return (
    <div className={s.root}>
      <Container>
        <div className={s.header}>
          <h2 dangerouslySetInnerHTML={{ __html: t2.title }} />
          <h3 dangerouslySetInnerHTML={{ __html: t2.title2 }} />
          <div className={s.divider} />
          <div dangerouslySetInnerHTML={{ __html: t2.description }} />
        </div>


        <div className={s.header}>
          <h2 dangerouslySetInnerHTML={{ __html: t2.project.title }} />
          <h3 className={s.projectOptions} dangerouslySetInnerHTML={{ __html: t2.project.options }} />
          <ol>
            <li dangerouslySetInnerHTML={{ __html: t2.project.option1 }} />
          </ol>
        </div>

        <h3 className="mb-3">Nasze projekty: </h3>

        {t2.project.workshops.map((workshop) => (
          ShowWorkshopLong(workshop)
        ))}


        <ol start={2}>
          <li dangerouslySetInnerHTML={{ __html: t2.project.option2 }}/>
        </ol>
        

      </Container>


      <Container className="mt-5">
        <div className="mb-2">
          <h3 dangerouslySetInnerHTML={{ __html: t.projectSectionTitle }} />
          <div className={s.line} />
          {t.topics.map((topic) => (
            <div className={s.projectName} dangerouslySetInnerHTML={{ __html: topic.longDescription }} />
          ))}

        </div>

      </Container>
    </div>
  )
}

export function ShowWorkshopLong(workshop) {

  const myRef = useRef(null)


  const [showFullDesc, setShowDesc] = React.useState(false)
  const [workshopButton, changeButton] = React.useState("Zobacz więcej ⬇")

  const toggleFullDesc = () => {

    showFullDesc ? changeButton("Zobacz więcej ⬇") : changeButton("Ukryj ⬆")

    if (showFullDesc) {
      window.scrollTo({top: myRef.current.offsetTop - 100, behavior: "smooth"});
    }

    setShowDesc(!showFullDesc)

  }

  return (
    <div className="mb-5" ref={myRef}>

      <div className="d-flex flex-column justify-content-center align-items-center mb-3">
        <div className={s.projectName + " mb-3"} dangerouslySetInnerHTML={{ __html: workshop.title }} />
        <div className="my-3">{workshop.desc}</div>
        
      </div>
      
      <Collapse isOpen={showFullDesc}>
        <div className={s.projectName} dangerouslySetInnerHTML={{ __html: workshop.longDesc }} />
        <div className={s.projectName} dangerouslySetInnerHTML={{ __html: workshop.mentorsDesc }} />
      </Collapse>
      <div className="text-center">Zarezerwuj miejsce na warsztaty wprowadzające w tematykę projektu</div>
      <div className="d-flex justify-content-center align-items-center">
        <Button color="primary" className="my-4" onClick={toggleFullDesc}>{workshopButton}</Button>
        <a className="text-decoration-none" href="https://app.evenea.pl/event/hack4change2022warsztaty/">
          <Button color="primary" className="ml-4">Zapisz się!</Button>
        </a>
      </div>
    </div>
  )
}
